import Keycloak, {} from 'keycloak-js';
import { ConfigurationManager } from '../ConfigurationManager';
import { isArray } from 'chart.js/helpers';
export const ADVERTISER = "advertiser";
export const GAME_COMPANY = "gamecompany";
export const ADMIN = "admin";
/**
 * A class containing all information for the authenticated user
 */
export class AuthInfo {
    companyId;
    roles;
    token;
    interval;
    constructor(token, roles, company) {
        this.companyId = company;
        this.roles = roles;
        this.token = token;
        console.log("TOKEN:");
        console.log(this.token);
        let self = this;
        this.interval = setInterval(() => {
            self.updateToken();
        }, 60 * 1000);
    }
    isAdvertiser() {
        return this.roles.indexOf(ADVERTISER) >= 0;
    }
    isGameCompany() {
        return this.roles.indexOf(GAME_COMPANY) >= 0;
    }
    isAdmin() {
        return this.roles.indexOf(ADMIN) >= 0;
    }
    getCompanyId() {
        return this.companyId;
    }
    getRoles() {
        return this.roles;
    }
    getToken() {
        return this.token;
    }
    updateToken() {
        let self = this;
        keycloak.updateToken(5).then((refreshed) => {
            if (refreshed) {
                self.token = keycloak.token;
                console.log('successfully get a new token', keycloak.token);
            }
        }).catch((err) => {
            console.error('Could not refresh token', err);
        });
    }
}
let authInfo = null;
export function getAuthInfo() {
    return authInfo;
}
let cfg = undefined;
let keycloak = null;
/**
 * Called to initiate initial authentication or redirect to login
 * @param successCallback
 */
export async function requireAuth(successCallback) {
    if (!keycloak) {
        cfg = ConfigurationManager.getInstance().keycloakConfig;
        if (cfg) {
            keycloak = new Keycloak(cfg);
            try {
                const authenticated = await keycloak.init({
                    onLoad: "login-required"
                });
                if (authenticated) {
                    console.log('User is authenticated');
                    let profile = await keycloak.loadUserProfile();
                    let roles = [];
                    if (keycloak.hasRealmRole(ADVERTISER)) {
                        roles.push(ADVERTISER);
                    }
                    if (keycloak.hasRealmRole(GAME_COMPANY)) {
                        roles.push(GAME_COMPANY);
                    }
                    if (keycloak.hasRealmRole(ADMIN)) {
                        roles.push(ADMIN);
                    }
                    authInfo = new AuthInfo(keycloak.token, roles, profile.attributes && isArray(profile.attributes["company"]) && profile.attributes["company"].length > 0 ? profile.attributes["company"][0] : null);
                    successCallback();
                }
                else {
                    console.log('User is not authenticated');
                    keycloak.login();
                }
                keycloak.refreshToken;
            }
            catch (error) {
                console.error('Failed to initialize adapter:', error);
            }
        }
        else {
            authInfo = new AuthInfo(null, [ADVERTISER, GAME_COMPANY], "Adelbert und Söhne");
            successCallback();
        }
    }
}
